import React from 'react';
import styles from './Modal.module.css'
import cx from "classnames";
import {useGlobalContext} from "../../contexts/GlobalContext";

const Modal: React.FC = () => {

    const {useModal: {modal, closeModal}} = useGlobalContext()

    return modal.visible ? (
        <div className={cx(styles['zr-modal-overlay'])}>
            <div className={cx(styles['zr-modal-content'])} style={{width: modal.width ?? ''}}>
                <button className={cx(styles['zr-close-button'])} onClick={() => closeModal()}>
                    &times;
                </button>
                {modal.heading && (
                    <div className={cx(styles['zr-modal-header'])}>
                        {modal.heading}
                    </div>
                )}
                {modal.content}
            </div>
        </div>
    ) : (
        <></>
    );
};

export default Modal;
